import { Dialog } from "@/dentlab/src/components/ui/dialog";
import {
	DialogContent,
	DialogHeader,
	DialogTitle,
} from "@/dentlab/src/components/ui/dialog";
import { NewConnectRelationship } from "@/dentlab/src/pages/client-chat-page/new-relationship/new-connect-relationship-dialog.component";

interface ConnectBeforeShareDialogProps {
	open: boolean;
	onClose: () => void;
	onConnectionSuccess?: (email: string) => void;
}

export const ConnectBeforeShareDialog: React.FC<
	ConnectBeforeShareDialogProps
> = ({ open, onClose, onConnectionSuccess }) => {
	const handleConnectionSuccess = (email: string) => {
		onClose();
		if (onConnectionSuccess) {
			onConnectionSuccess(email);
		}
	};

	return (
		<Dialog open={open} onOpenChange={onClose}>
			<DialogContent className="max-w-xl">
				<DialogHeader>
					<DialogTitle>Verbindung erforderlich</DialogTitle>
				</DialogHeader>
				<div className="mb-4">
					<p className="text-sm text-gray-600">
						Um Dokumente per E-Mail (mit sicherem Download über
						dentCONNECT) zu versenden, müssen Sie zuerst die E-Mail
						Adresse des Kunden hinterlegen.
					</p>
				</div>
				<NewConnectRelationship
					onConnectionSuccess={handleConnectionSuccess}
				/>
			</DialogContent>
		</Dialog>
	);
};
